import $ from 'jquery';
import Swiper, {Navigation, Autoplay, Mousewheel, EffectFade, Pagination, Grid} from 'swiper'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

Swiper.use([Navigation, Autoplay, Mousewheel, EffectFade, Pagination, Grid])

let newsSlider = $('.news-slider__slider');

if (newsSlider.length > 0) {
  newsSlider.each(function () {
    let newsSliderSwiper = new Swiper(this, {
      slidesPerView: 1,
      loop: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    });

    $(this).mouseenter(function() {
      (this).swiper.autoplay.stop();
    });

    $(this).mouseleave(function() {
      (this).swiper.autoplay.start();
    });

    newsSliderSwiper.init();
  });
}

